import React from 'react'
import LargeCard from '../../components/core/card/LargeCard'
import data from './data'
import uptimeIcon from '../../assets/images/uptime.svg'
import pingIcon from '../../assets/images/ping.svg'
import jsonIcon from '../../assets/images/json.svg'
import keywordIcon from '../../assets/images/keyword.svg'
import sitemapIcon from '../../assets/images/sitemap.svg'
import udpIcon from '../../assets/images/udp.svg'
import tcpIcon from '../../assets/images/tcp.svg'
import mailServerIcon from '../../assets/images/mail-server.svg'
import statusCodeIcon from '../../assets/images/status-code.png'
import Tooltip from '../../components/core/tooltip'
import text from './text.json'
import plans from '../../data/plans.json'

const resourceIcons = {
    uptime_icon: uptimeIcon,
    ping_icon: pingIcon,
    json_icon: jsonIcon,
    keyword_icon: keywordIcon,
    sitemap_icon: sitemapIcon,
    udp_icon: udpIcon,
    tcp_icon: tcpIcon,
    mail_server_icon: mailServerIcon,
    status_code_icon: statusCodeIcon
}

const plansData = Object.values(plans)

function ResourceSuggestion({onAddResource, shouldButtonHighlight, isDarkMode}) {
    const currentPlan = localStorage.getItem('plan')
    const planName = plansData.find(plan => plan.key === currentPlan)?.name

    return (
        <div className='resource-suggestion-body'>
            {data.available_resources.map((resourceKey) => {
                const resource = data.resource_types[resourceKey]
                const isDisabled = currentPlan === plans.free_v2.key || data.plan_values[planName] < data.plan_values[resource.available_from]
                return (
                    isDisabled ?
                        <Tooltip
                            trigger="mouseenter"
                            placement="top"
                            content={text.premium_feature}
                        >
                            <LargeCard
                                key={resource.key}
                                title={resource.title}
                                content={resource.content}
                                icon={resourceIcons[resource.icon]}
                                buttonText={resource.button_text}
                                tag={resource.tag}
                                onClick={() => onAddResource(resource)}
                                highlight={shouldButtonHighlight && resource.key === data.resource_types.uptime_resource.key}
                                disabled={isDisabled}
                                isDarkMode={isDarkMode}
                            />
                        </Tooltip> :
                        <LargeCard
                            key={resource.key}
                            title={resource.title}
                            content={resource.content}
                            icon={resourceIcons[resource.icon]}
                            buttonText={resource.button_text}
                            tag={resource.tag}
                            onClick={() => onAddResource(resource)}
                            highlight={shouldButtonHighlight && resource.key === data.resource_types.uptime_resource.key}
                            isDarkMode={isDarkMode}
                        />
                )
            })}
        </div>
    )
}

export default ResourceSuggestion
